import { render, staticRenderFns } from "./ImageManage.vue?vue&type=template&id=451f707c&scoped=true&"
import script from "./ImageManage.vue?vue&type=script&lang=js&"
export * from "./ImageManage.vue?vue&type=script&lang=js&"
import style0 from "./ImageManage.vue?vue&type=style&index=0&id=451f707c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451f707c",
  null
  
)

export default component.exports